import {
  ParamsGetFramesFromHistory,
  RequestGetTimelineFromHistory,
} from '../../../models/manager-content-vehicle-history-drawer.model';
import { adaptDateForParamsGetFramesFromHistory } from './adapt-request-get-frames.adapter';

export function adaptParamsGetTimelineFromHistory(
  params: ParamsGetFramesFromHistory
): RequestGetTimelineFromHistory {
  const start_date = adaptDateForParamsGetFramesFromHistory(
    params.start_date,
    params.time_start
  );
  const end_date = adaptDateForParamsGetFramesFromHistory(
    params.end_date,
    params.time_end
  );

  return {
    startDate: start_date,
    endDate: end_date,
    imei: params.unit.GNSSIMEI,
    options: {
      minStopDurationSeconds: 60,
    },
  };
}
